import { Page_settings } from "@/config/page_settings";
import { deviceWidth } from "@/design/defaultTheme";
import { useWindowSize } from "@/hooks/useWindowSize";
import { rootStore } from "@/mobx/store";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Button from "@/components/button";
import colors from "@/design/colors";
import styled from "styled-components";
import BasicTable from "@/components/table/BasicTable";

const CatList = (
    {goToCreateMode}: {goToCreateMode: () => void}
) => {
  /* **********************************
   * GLOBAL STATE
   * 전역 상태 및 전역 변수
   ********************************** */
  const context: any = useContext(Page_settings);
  const token = rootStore.getMe?.accessToken;
  const { width } = useWindowSize();
  const isMobile = width < deviceWidth.mobile;
  const navigate = useNavigate();


  /* **********************************
   * LOCAL STATE
   * 컴포넌트 내부에서 사용하는 상태
   ********************************** */
  
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20; // 한 페이지당 보여줄 항목 수
  const [totalCount, setTotalCount] = useState(0);
  const { id } = useParams();
  const [catList, setCatList] = useState([])
  /* **********************************
   * Handler
   * 이벤트 핸들러
   ********************************** */
  // 플랫폼 목록 조회
  const getCatList = async () => {
    context.post(
      `/office/getCatList`,
      {
        pageNumber: currentPage,
        pageSize: pageSize,
        storeId: parseInt(id) 
      },
      (response) => {
        console.log(response);
        setTotalCount(response.totalCount);
        setCatList(response.resultList);
      }
    );
  };


  const deleteCat = (id: string) => {
    context.post(
        `/office/deleteCatInfo`,{
            catId: id
        },
        (response) => {
            getCatList()
        }
    )
  }

 /* **********************************
   * EFFECTS
   * 컴포넌트 상태 변경 처리
   ********************************** */
  useEffect(() => {
    getCatList();
  }, [currentPage, id]);

  // 데이터가 없을 경우 페이지 1로 설정
  useEffect(() => {
    if (totalCount === 0) setCurrentPage(1);
  }, [totalCount]);


    const catColumns = [
        {
            key: "id",
            header: "catId",
            width: "90px",
            render: (item) => <span>{item.externalId}</span>
        },{
            key: "type",
            header: "type",
            width: "60px",
            render: (item) => <span>{item.type}</span>
        },{
          key: "createAt",
          header: "등록일시",
          width: "90px",
          render: (item) => <span>{item.createAt}</span>
      },{
          key: "deviceCount",
          header: "기기수",
          width: "60px",
          render: (item) => <span>{item.deviceCount}</span>
      },{
          key: "delete",
          header: "삭제",
          width: "60px",
          render: (item) => {
            return (
              <div style={{ display: "flex", justifyContent: "center" }}>
                {item.type === "OFFLINE" && (
                  <Button
                  text="삭제"
                  size="small"
                  width="30%"
                  height="28px"
                  buttonColor={colors.warning}
                  textColor={colors.white}
                  onClick={() => {
                    deleteCat(item.externalId);
                  }}
                />)}
              </div>
            )
          }
      }
    ]


    return (
        <Container>
          <Row>
            <Button
              text="CAT ID 등록"
              size="small"
              width="fit-content"
              height="32px"
              buttonColor={colors.blue600}
              textColor={colors.white}
              customFontSize={isMobile ? "11px" : "13px"}
              style={{
                padding: "0 10px",
              }}
              onClick={goToCreateMode}
            />
          </Row>
          <BasicTable
              data={catList}
              columns={catColumns}
              rowKey="id"
              showCheckbox={false}
              emptyMessage="catId 가 존재하지 않습니다."
              totalPages={Math.max(1, Math.ceil(totalCount / pageSize))}
              onPageChange={(page) => setCurrentPage(page)}
              showPagination={true}
              rowCursorPointer={false}
          />
          </Container>
        )
}

const Container = styled.div`
  height: 100%
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
`

export default CatList;